export default __webpack_public_path__ + "static/media/Cushion@3x.ffc118ec.png";